
const RouterPath = {

  redirect: '/home',
  home: '/home',

  publish: '/publish',
  publishWish: '/publish/wish',
  publishFree: '/publish/free',
  publishRedPacket: '/publish/packet',
  publishRPDetail: '/publish/packet/detail',
  systemRPDetail: '/home/system/packet',


  publishRecord: '/publish/record',

  discover: '/discover',

  mocicle: '/mocicle',
  mcicleList:'/mocicle-list',
  FreeDesire:"/publish/Free-desire",
  mochat: '/mochat',
  mochatDialogue: '/mochat/dialogue',
  contact: '/contact',
  mochatGroupMgr: '/mochat/group/mgr',
  mochatSingleMgr: '/mochat/single/mgr',
  mochatGroupAlbums: '/mochat/group/albums',

  FriendRequestInfo:'/mochat/friend-req-info',


  mine: '/mine',
  setting: '/setting',
  settingSet: '/setting/set',
  profile: '/common/user-profile',
  othersProfile: '/common/others-profile',
  ownInfo: '/setting/own-info',
  infoModify: '/setting/info-modify',
  wallet: '/setting/wallet',
  walletRecord: '/setting/wallet/record',
  walletAliModify: '/setting/wallet/ali-modify',
  walletCash: '/setting/wallet/cash',
  MyOrder:'/setting/myorder',
  OrderDetail:'/setting/myorder/detail',

  login: '/login',
  register: '/register',
  phoneReset: '/phone-reset',
  phoneBind: '/phone-bind',
  pwdReset: '/pwd-reset',

  groupChats: '/contact/group-chats',
  requests: '/contact/requests',
  Find:'/find/find',
  Revenue:'/find/revenue',
  LocalPublis:'/publish/publish-local',
  SharePage: '/share',
  RealName:'/setting/real-name',
  RealCard:'/setting/real-card',
  CardSuccess:'/setting/card-success',
  Ament:'/ament',
  Advertise:'/home/startadvertise',
  PublishLocationSet:'/publish/location-set',
  Citylist:'/publish/Citylist',
  AddFrind:'/mochat/addfrind',
  Friendinformation:'/mochat/friendinformation',
  OrderDesire:'/setting/orderdesire',

  SelectLike: '/select-like',
  GuidePage: '/guid-page',

  Recipe: '/find/recipe',
  Qrcode: '/find/qrcode',
  Invite: '/find/invite',
}


RouterPath.install = function (Vue, options) {
  Vue.prototype.$router_path = RouterPath
}
export default RouterPath;



// WEBPACK FOOTER //
// ./src/plugins/router-path.js